import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  inject,
} from '@angular/core';
import { MenuItem } from 'primeng/api';
import { MenuModule } from 'primeng/menu';
import { SidebarModule } from 'primeng/sidebar';
import { ThemeStore } from '~/shared-common';
import { Router, RouterModule } from '@angular/router';
import { AuthStore, LocalStorageJwtService } from '../../stores/auth';
@Component({
  selector: 'app-sidebar',
  templateUrl: './app-sidebar.component.html',
  styleUrls: ['./app-sidebar.component.scss'],
  standalone: true,
  imports: [SidebarModule, MenuModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppSidebarComponent implements OnInit {
  private router = inject(Router);
  readonly themeStore = inject(ThemeStore);
  $sidebarVisible = this.themeStore.isOpenSidebar;
  items: MenuItem[] | undefined;
  private readonly authStore = inject(AuthStore);

  onVisibleChange(e: boolean) {
    if (!e) {
      this.themeStore.toggleSidebar();
    }
  }

  toggleSidebar() {
    this.themeStore.toggleSidebar();
  }

  logout(): void {
    this.authStore.setLoggedOut(0);
    this.router.navigateByUrl('/auth/login');
  }
  ngOnInit(): void {}
}
